import type { ContainerGuideItem } from '@tunein/web-api-client';
import ListLayout from '../list/ListLayout';
import { ProfileHeader } from './ProfileHeader';

type HeaderlessCardProps = {
  containerItem: ContainerGuideItem;
  id: string;
};

export function HeaderlessCard(props: HeaderlessCardProps) {
  const mappedChildren = props.containerItem.children
    .map((item) => {
      if (item.layout === 'ProfileHeader' || item.layout === 'GameProfileHeader') {
        return <ProfileHeader key={item.guideId} guideItem={item} id={props.id} />;
      }
    })
    .filter(Boolean);

  return mappedChildren.length ? mappedChildren : <ListLayout {...props} />;
}
